// Environment configuration for different deployment targets
export const environments = {
  development: {
    convexUrl: "https://exciting-goose-185.convex.cloud",
    apiBaseUrl: "https://api.dev.example.com",
    jamfBaseUrl: "https://jamf.kphone.org",
    enableDebugMode: true,
    logLevel: "debug" as const,
  },
  staging: {
    convexUrl: "https://exciting-goose-185.convex.cloud",
    apiBaseUrl: "https://api.staging.example.com",
    jamfBaseUrl: "https://jamf.kphone.org",
    enableDebugMode: false,
    logLevel: "info" as const,
  },
  production: {
    convexUrl: "https://exciting-goose-185.convex.cloud",
    apiBaseUrl: "https://api.example.com",
    jamfBaseUrl: "https://jamf.kphone.org",
    enableDebugMode: false,
    logLevel: "error" as const,
  }
} as const;

// Auto-detect environment based on hostname or manual override
const detectEnvironment = (): keyof typeof environments => {
  // Check for manual override in development
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const envOverride = urlParams.get('env') as keyof typeof environments;
    if (envOverride && environments[envOverride]) {
      return envOverride;
    }
  }

  // Auto-detect based on hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    if (hostname.includes('staging')) return 'staging';
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) return 'development';
    return 'production';
  }

  // Fallback for server-side or unknown environments
  return 'development';
};

export const currentEnvironment = detectEnvironment();
export const config = environments[currentEnvironment];

// Import dynamic Convex URL from deployments config
import { getCurrentConvexUrl } from "./deployments";

// Export individual config values for easy importing
export const convexUrl = getCurrentConvexUrl();
export const {
  apiBaseUrl,
  jamfBaseUrl,
  enableDebugMode,
  logLevel
} = config;

// Utility function to check current environment
export const isDevelopment = currentEnvironment === 'development';
export const isStaging = currentEnvironment === 'staging';
export const isProduction = currentEnvironment === 'production';